<script setup lang="ts">
import { computed } from 'vue';
import { useCustomFieldProps } from '@satellite/composables/useCustomFieldProps';
import { useCustomFieldValidation } from '@satellite/composables/useCustomFieldValidation';

import type { CustomFieldProps } from '../types';
import CustomFieldInputBase from '../CustomFieldInputBase.vue';

/**
 * Number field type - numeric input
 */
const props = defineProps<CustomFieldProps>();

const emit = defineEmits<{
  'update:model-value': [value: number];
  /** @deprecated Use update:model-value instead */
  // TODO: Remove this event after the migration is complete
  input: [value: number];
}>();

const { normalizedProps } = useCustomFieldProps(props);
const { rules } = useCustomFieldValidation(computed(() => props.field));

function handleInput(value) {
  emit('update:model-value', Number(value));
  emit('input', Number(value));
}
</script>

<template>
  <custom-field-input-base :field="field" v-bind="normalizedProps">
    <v-text-field
      :model-value="modelValue"
      :rules="rules"
      :readonly="normalizedProps.readOnly"
      :hide-details="normalizedProps.hideDetails"
      :variant="normalizedProps.outlined ? 'outlined' : 'filled'"
      :persistent-placeholder="normalizedProps.persistentPlaceholder"
      :placeholder="field.placeholder"
      type="number"
      density="comfortable"
      @update:model-value="handleInput" />
  </custom-field-input-base>
</template>
